export enum ChunkHashAlgorithm {
	Sha1 = 'sha1',
	Sha256 = 'sha256',
}
